import React, {useState, useEffect} from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import ModalHoraire from "./ModalHoraires";
import ModalAnnulationModifs from "./ModalAnnulationModifs";
import '../css/ModalModification.css'
import { Recuperer_coord_avec_adresse } from "./Fonctions_Geolocalisation";


const rechercher_coordonnées = async (establishment_to_modify, setEstablishmentToModify) => {
  if (
    establishment_to_modify.numero &&
    establishment_to_modify.voirie &&
    establishment_to_modify.ville &&
    establishment_to_modify.code_postal
  ) {
    const fullAddress = `${establishment_to_modify.numero} ${establishment_to_modify.voirie}, ${establishment_to_modify.ville}, ${establishment_to_modify.code_postal}`.trim();

    try {
      const geocodeUrl = `https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(fullAddress)}`;
      const response = await fetch(geocodeUrl);
      const data = await response.json();
      console.log(data);

      if (data.features && data.features.length > 0) {
        const { coordinates } = data.features[0].geometry;
        const [longitude, latitude] = coordinates;
        console.log("Coordonnées trouvées :", latitude, longitude);

        // Création d'un nouvel objet avec les mises à jour
        let updatedEstablishment = {
          ...establishment_to_modify,
          longitude:longitude,
          latitude:latitude,
          coords: [latitude, longitude]
        };

        try {
          const proprietes = data.features[0].properties;
          const { city, postcode, street, housenumber, label } = proprietes;

          updatedEstablishment = {
            ...updatedEstablishment,
            ville: city || establishment_to_modify.ville,
            code_postal: postcode || establishment_to_modify.code_postal,
            voirie: street || establishment_to_modify.voirie,
            numero: housenumber || establishment_to_modify.numero,
            adresse_finale: label || establishment_to_modify.adresse_finale
          };

        } catch (error) {
          console.error("Erreur lors de la récupération des propriétés :", error);
        }

        // Met à jour l'état avec la nouvelle version
        setEstablishmentToModify(updatedEstablishment);

        // Retourne l'objet mis à jour
        return updatedEstablishment;
      } else {
        console.error("Aucune adresse trouvée.");
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des coordonnées :", error);
    }
  }
};


async function pushHoraires(establishment_to_modify) {
  try {
    
    
    const response = await fetch("https://carto.api.toobib.org/api/ajout_horaires", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(establishment_to_modify),
    });

    if (!response.ok) {
      throw new Error(`Error adding horaires: ${response.statusText}`);
    }

    const data = await response.json();
    console.log("Horaires added successfully:", data);
    return data;
  } catch (err) {
    console.error("Error pushing horaires:", err);
  }
}

const push_modif = async (
  establishment_to_modify,
  setEstablishmentToModify,
  email,
  setOuvrirFenetreModifications,
  setShowThankYouModal
) => {
  try {
    await pushHoraires(establishment_to_modify);

    const updatedEstablishment = await rechercher_coordonnées(establishment_to_modify, setEstablishmentToModify);

    if (!updatedEstablishment) {
      console.error("Erreur : les coordonnées n'ont pas été récupérées.");
      return;
    }

    const { coords } = updatedEstablishment;
    const [lat, lon] = coords || [];

    if (!lat || !lon) {
      console.error("Erreur : Latitude et longitude non définies.");
      return;
    }

    const payload = {
      ...updatedEstablishment,
      email,
    };

    const response = await fetch(
      `https://carto.api.toobib.org/api/upsert_finess_modifications?lat=${lat}&lon=${lon}&email=${email}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      throw new Error(`Error updating finess_modifications: ${response.statusText}`);
    }

    const data = await response.json();
    console.log("Data successfully updated:", data);

    setOuvrirFenetreModifications(false);
    setShowThankYouModal(true);
  } catch (err) {
    console.error("Error pushing modifications:", err);
  }
};


const ModalModification = ({
  ouvrirFenetreModifications,
  setOuvrirFenetreModifications,
  establishment_to_modify,
  setEstablishmentToModify,
  sousCategories,
  email,
  RecenterModal,
  setShowThankYouModal
}) => {
  const [isModalHorairesOpen, setIsModalHorairesOpen] = useState(false);

  const [annulationModifModal, setAnnulationModifModal] = useState(false);
  console.log(establishment_to_modify)
  


  const [geocodeResults, setGeocodeResults] = useState([]);
  console.log(geocodeResults)
  
  const handleSelectResult = (result) => {
    
    setEstablishmentToModify((prevState) => {
      return {
        ...prevState,
        latitude: result.coordinates[1],
        longitude: result.coordinates[0],
        adresse_finale: result.label,
        coords: [result.coordinates[1], result.coordinates[0]],
        voirie: result.street,
        code_postal: result.postcode,
        ville: result.city,
        numero: result.houseNumber,
      };
    });
    
    setGeocodeResults([]); 
    
  };

  useEffect(() => {
      if (establishment_to_modify.adresse_finale && establishment_to_modify.adresse_finale.trim() === '') {
        setGeocodeResults([]); 
        return;
      }
      const debounceTimer = setTimeout(() => {
          Recuperer_coord_avec_adresse(establishment_to_modify.adresse_finale, setGeocodeResults);
      }, 300); 

    return () => clearTimeout(debounceTimer); 
  }, [establishment_to_modify.adresse_finale]);


  const handleCancel = () => {
    setAnnulationModifModal(false);
    setOuvrirFenetreModifications(false);
    setEstablishmentToModify({});
  };
  if (!ouvrirFenetreModifications) return null;
  
  
  
  return (
    <div className="modal-backdrop">
      
      
      
      
                
      <ModalAnnulationModifs 
        isOpen={annulationModifModal} 
        onClose={() => setAnnulationModifModal(false)} 
        onConfirm={handleCancel} 
      />
      <div
        className="modal-content"
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            rechercher_coordonnées(establishment_to_modify, setEstablishmentToModify) 
          }
        }}
      >
        <button
          className="modal-close"
          onClick={() => setAnnulationModifModal(true)}
        >
          ×
        </button>
        <div>
          <input
            type="text"
            placeholder="Nom de l'établissement"
            className="edit-input titre"
            value={establishment_to_modify.nom}
            onChange={(event)=>
              setEstablishmentToModify((prevState) => ({
                ...prevState,
                nom: event.target.value,
              }))
            }/></div>
        <div className="modif-input-container">
          <input
            type="text"
            placeholder="N°"
            className="edit-input numero"
            value={establishment_to_modify.numero || ""}
            onChange={async (event) =>
              setEstablishmentToModify((prevState) => ({
                ...prevState,
                numero: event.target.value,
                adresse_finale: `${event.target.value} ${establishment_to_modify.voirie} ${establishment_to_modify.code_postal} ${establishment_to_modify.ville}`
              }))
              
            }
          />
          <input
            type="text"
            placeholder="Voirie"
            className="edit-input voirie"
            value={establishment_to_modify.voirie || ""}
            onChange={(event) =>
              setEstablishmentToModify((prevState) => ({
                ...prevState,
                voirie: event.target.value,
                adresse_finale: `${establishment_to_modify.numero} ${event.target.value} ${establishment_to_modify.code_postal} ${establishment_to_modify.ville}`
              }))
            }
          />
          <input
            type="text"
            placeholder="Ville"
            className="edit-input ville"
            value={establishment_to_modify.ville || ""}
            onChange={(event) =>
              setEstablishmentToModify((prevState) => ({
                ...prevState,
                ville: event.target.value,
                adresse_finale: `${establishment_to_modify.numero} ${establishment_to_modify.voirie} ${establishment_to_modify.code_postal} ${event.target.value}`
              }))
            }
          />
          <input
            type="text"
            placeholder="CP"
            className="edit-input code_postal"
            value={establishment_to_modify.code_postal || ""}
            onChange={(event) =>
              setEstablishmentToModify((prevState) => ({
                ...prevState,
                code_postal: event.target.value,
                adresse_finale: `${establishment_to_modify.numero} ${establishment_to_modify.voirie} ${event.target.value} ${establishment_to_modify.ville}`
              }))
            }
          />
        </div>
        <div className="modif-input-container">
          <input
            type="text"
            placeholder="Téléphone"
            className="edit-input telephone"
            value={establishment_to_modify.telephone || ""}
            onChange={(event) =>
              setEstablishmentToModify((prevState) => ({
                ...prevState,
                telephone: event.target.value,
              }))
            }
          />
          <select
            className="edit-input categorie"
            value={establishment_to_modify.sous_categorie || ""}
            onChange={(event) =>
              setEstablishmentToModify((prevState) => ({
                ...prevState,
                sous_categorie: event.target.value,
              }))
            }
          >
            <option value="" disabled>
              Choisissez une catégorie
            </option>
            {sousCategories.map((category, index) => (
              <option key={index} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>
        <div className="map-container">
          <MapContainer
            center={establishment_to_modify.coords}
            zoom={13}
            style={{ width: "100%", height: "100%" }}
          >
            <RecenterModal
              coordinates={{
                lat: establishment_to_modify.coords[0],
                lng: establishment_to_modify.coords[1],
              }}
            />
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            <button
              onClick={()=>rechercher_coordonnées(establishment_to_modify, setEstablishmentToModify)}
              className="popup-button"
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                height: "30px",
                width: "30px",
                zIndex: 1000,
              }}
            >
              <img
                src="lieu.png"
                alt="Reload"
                className="popup-button-image"
                style={{ height: "70%" }}
              />
            </button>
            <Marker
              position={establishment_to_modify.coords}
              icon={L.icon({
                iconUrl: "epingle.png",
                iconSize: [35, 35],
                iconAnchor: [17.5, 35],
                popupAnchor: [0, -35],
                shadowUrl: "epingle_shadow.png",
                shadowSize: [41, 41],
              })}
            >
              <Popup>You are here</Popup>
            </Marker>
          </MapContainer>
        </div>
        <div className="modal-footer">
          <button className="pop-up_modif_button" onClick={()=>push_modif(establishment_to_modify, setEstablishmentToModify, email, setOuvrirFenetreModifications, setShowThankYouModal)}>
            Valider les modifications
          </button>
          <button className="pop-up_right_button" onClick={() => setIsModalHorairesOpen(true)}>
            <img src="horaires.png" alt="Icon" />
          </button>
          {isModalHorairesOpen && (
            <ModalHoraire
              horaires={establishment_to_modify.horaires}
              setHoraires={(newHoraires) =>
                setEstablishmentToModify((prev) => ({ ...prev, horaires: newHoraires }))
              }
              onClose={() => setIsModalHorairesOpen(false)}
            />
          )}
        </div>
      </div>
      {geocodeResults.length > 0 && (
        <div className="geocode-popup">
          <div className="geocode-title">Sélectionnez l'adresse de l'établissement</div>
          <div className="geocode-list">
            {geocodeResults.map((result, index) => (
              <div
                key={index}
                className="geocode-item"
                onClick={() => handleSelectResult(result)}
              >
                {result.label}
              </div>
            ))}
          </div>
        </div>
      )}



    </div>
  );
};

export default ModalModification;
